import { isDate } from 'date-fns';
export const isValidDate = (value) => {
    if (value) {
        if (!value.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_date'
            };
        }
        if (!isDate(new Date(value))) {
            return {
                valid: Boolean(false),
                name: 'invalid_date'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
export const isValidTelNo = (value) => {
    if (value) {
        if (!value.match(/^[0-9]+(\.[0-9]+)?$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_tel_no'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
export const isZenkaku = (value) => {
    if (value) {
        const regex = /^[^ -~｡-ﾟ]+$/;
        return {
            valid: regex.test(value),
            name: 'not_zenkaku'
        };
    }
    return { valid: Boolean(true), name: '' };
};
